import { useApiWithAuth } from "@/modules/api";

interface FeaturePayload {
  idFeature: number;
  nome: string;
  descricao?: string | null;
  flPadrao?: boolean | null;
  flAtivo?: boolean | null;
  flHabilitada?: boolean | null;
  temRegistro?: boolean | null;
  habilitada?: boolean | null;
}

interface FeatureClienteUpdatePayload {
  idFeature: number;
  flHabilitada: boolean;
}

const useFeatureService = () => {
  const { data, loading, get, put } = useApiWithAuth();

  const getFeaturesCliente = (): Promise<void> => {
    return get("/cliente/features");
  };

  const getFeaturesClienteRoot = (idCliente: number): Promise<void> => {
    return get(`/root/cliente/${idCliente}/features`);
  };

  const updateFeaturesClienteRoot = (
    idCliente: number,
    features: Array<FeatureClienteUpdatePayload>
  ): Promise<void> => {
    return put(`/root/cliente/${idCliente}/features`, features);
  };

  const safeFeatures = (
    entities?: Array<FeaturePayload> | null
  ): Array<FeaturePayload> => {
    return entities ?? [];
  };

  return {
    data,
    loading,
    getFeaturesCliente,
    getFeaturesClienteRoot,
    updateFeaturesClienteRoot,
    safeFeatures
  };
};

export { useFeatureService, FeaturePayload, FeatureClienteUpdatePayload };
